import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                   */
const TitleWithIcon = ({
  label,
  icon,
  shouldHideIcon = false,
  shouldHideAsteriskSign = true
}) => /* @__PURE__ */ React.createElement("div", { className: "checkout-step-title" }, !shouldHideIcon && /* @__PURE__ */ React.createElement("div", { className: "checkout-step-title__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: icon })), /* @__PURE__ */ React.createElement(Text, { variant: "heading-small", component: "h2" }, label, !shouldHideAsteriskSign && /* @__PURE__ */ React.createElement("span", { className: "checkout-step-title__asterisk" }, "*")));
export {
  TitleWithIcon
};
//# sourceMappingURL=TitleWithIcon.js.map
